import {
  RESEND_VERIFICATION_EMAIL,
  RESEND_VERIFICATION_EMAIL_IS_ERROR,
  RESEND_VERIFICATION_EMAIL_IS_PENDING,
  ResendVerificationEmailActions,
  ResendVerificationEmailReducerState,
} from 'services/AuthService/ResendEmail/types';

const INITIAL_STATE = {
  resendVerificationEmailIsCompleted: false,
  resendVerificationEmailIsPending: false,
  resendVerificationEmailIsError: null,
} satisfies ResendVerificationEmailReducerState;

const resendVerificationEmailReducer = (
  previousState: ResendVerificationEmailReducerState | undefined,
  action: ResendVerificationEmailActions,
): ResendVerificationEmailReducerState => {
  const state: ResendVerificationEmailReducerState = previousState ?? INITIAL_STATE;

  switch (action.type) {
    case RESEND_VERIFICATION_EMAIL:
      return {
        ...state,
        resendVerificationEmailIsCompleted: true,
        resendVerificationEmailIsPending: false,
        resendVerificationEmailIsError: null,
      };
    case RESEND_VERIFICATION_EMAIL_IS_PENDING:
      return {
        ...state,
        resendVerificationEmailIsCompleted: false,
        resendVerificationEmailIsPending: true,
        resendVerificationEmailIsError: null,
      };
    case RESEND_VERIFICATION_EMAIL_IS_ERROR:
      return {
        ...state,
        resendVerificationEmailIsCompleted: true,
        resendVerificationEmailIsPending: false,
        resendVerificationEmailIsError: action.error,
      };
    default:
      return state;
  }
};

export default resendVerificationEmailReducer;
